export default "__VITE_ASSET__9vxHTugs__"